import { useState } from "react";
import styles from "./Input.module.css";

export const Input = ({
  label,
  type,
  name,
  value,
  onChange,
  error,
  onBlur,
  required,
  maxLength,
  placeholder,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  return (
    <div className={styles.wrapper}>
      <div className={styles.field}>
        <input
          id={name}
          name={name}
          type={isPassword && showPassword ? "text" : type}
          className={`${styles.input} ${value ? styles.filled : ""} ${
            error ? styles.inputError : ""
          }`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          placeholder={placeholder || " "}
          autoComplete="off"
          required={required}
        />

        <label htmlFor={name} className={styles.label}>
          {label}
        </label>

        {/* Toggle password visibility */}
        {isPassword && (
          <button
            type="button"
            className={styles.toggle}
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </button>
        )}
      </div>

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};
